export const isStandardOrg = (products: number[]) =>
  [115, 116, 117, 118].includes(products[0]);
